(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-consignment-wig-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('input[type="radio"]').forEach(function(input) {
    input.addEventListener('change', function() {
      const label = document.querySelector(`label[for="${input.id}"]`);
      const text = label ? label.textContent.trim() : '';
      console.log('Selected label:', text);
      // Yahan app ko update karne ka custom logic daalo if needed
    });
  });
});

  // price , variant id , addtocart and soldout change on variant 
  document.addEventListener('DOMContentLoaded', function () {
    const productJsonTag = document.querySelector('script[type="application/json"][data-product]');
    if (!productJsonTag) {
      console.warn('Product JSON not found.');
      return;
    }

    const productData = JSON.parse(productJsonTag.textContent);
    const allVariants = productData.variants;
    const currencyCode = window?.Shopify?.currency?.active || 'USD';

    const variantInput = document.querySelector('input.product_var');
    const addToCartBtn = document.querySelector('button.product-form__submit');
    const addToCartText = addToCartBtn?.querySelector('span');

    document.querySelectorAll('variant-selects').forEach(function (variantSelectEl) {
      const optionInputs = variantSelectEl.querySelectorAll('input[type="radio"]');

      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          const inputName = input.name;

          // Remove checked class
          const groupInputs = variantSelectEl.querySelectorAll(`input[name="${CSS.escape(inputName)}"]`);
          groupInputs.forEach(groupInput => {
            const label = variantSelectEl.querySelector(`label[for="${groupInput.id}"]`);
            if (label) label.classList.remove('checked');
          });

          // Add checked class to selected one
          const selectedLabel = variantSelectEl.querySelector(`label[for="${input.id}"]`);
          if (selectedLabel) selectedLabel.classList.add('checked');

          // Collect selected options
          const selectedOptions = [];
          const fieldsets = variantSelectEl.querySelectorAll('fieldset');
          fieldsets.forEach(function (fieldset) {
            const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
            if (selectedInput) {
              selectedOptions.push(selectedInput.value.replace(/&quot;/g, '"'));
            }
          });

          // Match variant
          const matchedVariant = allVariants.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
          );

          const salePriceSpan = document.querySelector('.price-item--sale');
          const comparePriceSpans = document.querySelectorAll('.price-item--regular');

          if (matchedVariant && variantInput) {
            variantInput.value = matchedVariant.id;

            // Format sale price
            const formattedSalePrice = `${(matchedVariant.price / 100).toLocaleString('en-US', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} ${currencyCode}`;

            // Format compare price
            let formattedComparePrice = '';
            const hasComparePrice = matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price;
            if (hasComparePrice) {
              formattedComparePrice = `${(matchedVariant.compare_at_price / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })} ${currencyCode}`;
            }

            // Update prices
            if (salePriceSpan) salePriceSpan.textContent = formattedSalePrice;

            comparePriceSpans.forEach(el => {
              if (hasComparePrice) {
                el.textContent = formattedComparePrice;
                el.closest('.price__sale')?.classList.remove('hidden');
              } else {
                el.textContent = '';
                el.closest('.price__sale')?.classList.add('hidden');
              }
            });

            // Handle sold out logic
            if (matchedVariant.available) {
              addToCartBtn.removeAttribute('disabled');
              addToCartText.textContent = 'Add to cart';
              variantInput.disabled = false;
            } else {
              addToCartBtn.setAttribute('disabled', 'true');
              addToCartText.textContent = 'Sold out';
              variantInput.disabled = true;
            }

            console.clear();
            console.log('Selected Options:', selectedOptions);
            console.log('Variant ID:', matchedVariant.id);
            console.log('Available:', matchedVariant.available);
          } else {
            console.warn('No matching variant or elements not found.');
          }
        });

        // Trigger on load
        if (input.checked) {
          input.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  // active class on variant change
  document.addEventListener('DOMContentLoaded', function () {
    const colorTags = document.querySelectorAll('.single-color-tag');
    const currentPath = window.location.pathname; // e.g., /products/testing-product

    // Onload: Set active if href matches current URL
    colorTags.forEach(function(tag) {
      const href = tag.getAttribute('href');

      if (href === currentPath) {
        tag.classList.add('active');
      }
    });

    // On Click: Remove from all and add to clicked one
    colorTags.forEach(function(tag) {
      tag.addEventListener('click', function () {
        colorTags.forEach(function(t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
      });
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-content-slider-blocks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.content-slider-blocks .custom-content-slider-block').forEach(function (slider) {
    const slidesCount = slider.querySelectorAll('.content-slider-block').length;
    const showArrows = slidesCount > 3;

    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 52,
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 }
      },
      navigation: showArrows ? {
        nextEl: slider.parentElement.querySelector('.mhButton.next'),
        prevEl: slider.parentElement.querySelector('.mhButton.prev')
      } : false,
    });

    if (!showArrows) {
      slider.parentElement.querySelectorAll('.mhButton.next, .mhButton.prev').forEach(el => el.style.display = 'none');
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('input[type="radio"]').forEach(function(input) {
    input.addEventListener('change', function() {
      const label = document.querySelector(`label[for="${input.id}"]`);
      const text = label ? label.textContent.trim() : '';
      console.log('Selected label:', text);
      // Yahan app ko update karne ka custom logic daalo if needed
    });
  });
});

  // price , variant id , addtocart and soldout change on variant 
  document.addEventListener('DOMContentLoaded', function () {
    const productJsonTag = document.querySelector('script[type="application/json"][data-product]');
    if (!productJsonTag) {
      console.warn('Product JSON not found.');
      return;
    }

    const productData = JSON.parse(productJsonTag.textContent);
    const allVariants = productData.variants;
    const currencyCode = window?.Shopify?.currency?.active || 'USD';

    const variantInput = document.querySelector('input.product_var');
    const addToCartBtn = document.querySelector('button.product-form__submit');
    const addToCartText = addToCartBtn?.querySelector('span');

    document.querySelectorAll('variant-selects').forEach(function (variantSelectEl) {
      const optionInputs = variantSelectEl.querySelectorAll('input[type="radio"]');

      optionInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          const inputName = input.name;

          // Remove checked class
          const groupInputs = variantSelectEl.querySelectorAll(`input[name="${CSS.escape(inputName)}"]`);
          groupInputs.forEach(groupInput => {
            const label = variantSelectEl.querySelector(`label[for="${groupInput.id}"]`);
            if (label) label.classList.remove('checked');
          });

          // Add checked class to selected one
          const selectedLabel = variantSelectEl.querySelector(`label[for="${input.id}"]`);
          if (selectedLabel) selectedLabel.classList.add('checked');

          // Collect selected options
          const selectedOptions = [];
          const fieldsets = variantSelectEl.querySelectorAll('fieldset');
          fieldsets.forEach(function (fieldset) {
            const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
            if (selectedInput) {
              selectedOptions.push(selectedInput.value.replace(/&quot;/g, '"'));
            }
          });

          // Match variant
          const matchedVariant = allVariants.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
          );

          const salePriceSpan = document.querySelector('.price-item--sale');
          const comparePriceSpans = document.querySelectorAll('.price-item--regular');

          if (matchedVariant && variantInput) {
            variantInput.value = matchedVariant.id;

            // Format sale price
            const formattedSalePrice = `${(matchedVariant.price / 100).toLocaleString('en-US', {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })} ${currencyCode}`;

            // Format compare price
            let formattedComparePrice = '';
            const hasComparePrice = matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price;
            if (hasComparePrice) {
              formattedComparePrice = `${(matchedVariant.compare_at_price / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })} ${currencyCode}`;
            }

            // Update prices
            if (salePriceSpan) salePriceSpan.textContent = formattedSalePrice;

            comparePriceSpans.forEach(el => {
              if (hasComparePrice) {
                el.textContent = formattedComparePrice;
                el.closest('.price__sale')?.classList.remove('hidden');
              } else {
                el.textContent = '';
                el.closest('.price__sale')?.classList.add('hidden');
              }
            });

            // Handle sold out logic
            if (matchedVariant.available) {
              addToCartBtn.removeAttribute('disabled');
              addToCartText.textContent = 'Add to cart';
              variantInput.disabled = false;
            } else {
              addToCartBtn.setAttribute('disabled', 'true');
              addToCartText.textContent = 'Sold out';
              variantInput.disabled = true;
            }

            console.clear();
            console.log('Selected Options:', selectedOptions);
            console.log('Variant ID:', matchedVariant.id);
            console.log('Available:', matchedVariant.available);
          } else {
            console.warn('No matching variant or elements not found.');
          }
        });

        // Trigger on load
        if (input.checked) {
          input.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  // active class on variant change
  document.addEventListener('DOMContentLoaded', function () {
    const colorTags = document.querySelectorAll('.single-color-tag');
    const currentPath = window.location.pathname; // e.g., /products/testing-product

    // Onload: Set active if href matches current URL
    colorTags.forEach(function(tag) {
      const href = tag.getAttribute('href');

      if (href === currentPath) {
        tag.classList.add('active');
      }
    });

    // On Click: Remove from all and add to clicked one
    colorTags.forEach(function(tag) {
      tag.addEventListener('click', function () {
        colorTags.forEach(function(t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
